var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../../../../components/Table/Table';
import Button from '../../../../components/Button';
import styled from 'styled-components';
import Templates from '../../hooks';
import Icon from '../../../../components/Icon';
import ShowMoreButton from '../../../../components/Table/components/ShowMoreButton';
import ExpandedTemplateVersionHistory from './components/ExpandedTemplateVersionHistory';
import t from '../../../../lib/translate';
import SendWindowList from './components/SendWindowList';
export var ButtonWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin: 1em 0;\n  justify-content: flex-end;\n  button{\n    margin-left: 1em;\n  }\n"], ["\n  display: flex;\n  margin: 1em 0;\n  justify-content: flex-end;\n  button{\n    margin-left: 1em;\n  }\n"])));
export var IconWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:hover{\n    cursor: pointer;\n  }\n"], ["\n  &:hover{\n    cursor: pointer;\n  }\n"])));
export var DescriptionWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: grey;\n  font-size: 0.9em;\n"], ["\n  color: grey;\n  font-size: 0.9em;\n"])));
var TemplateList = function () {
    var _a = Templates.useContainer(), templates = _a.templates, translateTemplateKeys = _a.translateTemplateKeys;
    var navigate = useNavigate();
    var columns = useMemo(function () { return [
        {
            Header: t('templates.table.headers.key'),
            accessor: function (template) {
                return _jsx("div", { children: translateTemplateKeys ? t("templates.key.".concat(template.key)) : template.key });
            }
        },
        {
            Header: t('templates.table.headers.ownerparty'),
            accessor: function (template) { return template.ownerparty.name; }
        },
        {
            Header: t('templates.table.headers.channel'),
            accessor: 'channel'
        },
        {
            Header: t('templates.table.headers.latest'),
            accessor: 'version'
        },
        {
            Header: t('templates.table.headers.time.windows'),
            accessor: function (template) { return _jsx(SendWindowList, { windows: template.sendWindows }); }
        },
        {
            Header: '',
            expander: true,
            id: 'product.key.changelog',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Cell: function (_a) {
                var _b;
                var row = _a.row;
                if (((_b = row.values) === null || _b === void 0 ? void 0 : _b.version) === '1.0')
                    return _jsx(_Fragment, {});
                return (_jsx("span", __assign({}, row.getToggleRowExpandedProps, { onClick: function () { return row.toggleRowExpanded(); } }, { children: _jsx(ShowMoreButton, { open: !row.isExpanded, openText: t('templates.table.show.changelog'), closeText: t('templates.table.hide.changelog') }) })));
            }
        },
        {
            Header: '',
            id: 'product.key',
            accessor: function (template) {
                return _jsx(IconWrapper, { children: _jsx(Icon, { icon: "pen", onClick: function () { return navigate("/admin/templates/".concat(template.ownerparty.key, "/").concat(template.key, "/").concat(template.version.replace('.', '_'))); } }) });
            },
            disableSortBy: true
        }
    ]; }, [history, translateTemplateKeys]);
    var descriptionRow = useCallback(function (_a) {
        var row = _a.row;
        var translated = t("templates.description.".concat(row.original.key));
        var untranslated = ['', "templates.description.".concat(row.original.key), row.original.key];
        // only show description if it has been translated
        return untranslated.includes(translated)
            ? null
            : (_jsx("td", __assign({ colSpan: columns.length }, { children: _jsxs(DescriptionWrapper, { children: [t('templates.table.description'), " ", translated] }) })));
    }, [columns]);
    var historyRow = useCallback(function (_a) {
        var row = _a.row;
        return row.isExpanded
            ? (_jsx("td", __assign({ colSpan: columns.length, className: "expanded" }, { children: _jsx(ExpandedTemplateVersionHistory, { template: row.original }) })))
            : null;
    }, [columns]);
    if ((templates === null || templates === void 0 ? void 0 : templates.length) === 0)
        return _jsx("div", { children: t('general.loading') });
    return (_jsxs("div", { children: [_jsx("h1", { children: t('templates.header') }), _jsx(ButtonWrapper, { children: _jsx(Button, { onClick: function () { return navigate('/admin/templates/create'); }, text: t('templates.new') }) }), templates &&
                _jsx(Table, { columns: columns, data: templates, pagination: false, subRows: [descriptionRow, historyRow] })] }));
};
export default TemplateList;
var templateObject_1, templateObject_2, templateObject_3;
